import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NoData } from 'Components/InfoMessage';
import Footer from 'Pages/Footer';

export default () => {
  const supportLink = 'mailto:support@nuimarkets.com';
  return (
    <main>
      <div className="full-page-header inactive-account-page-header">
        <h1 className="inline mt-20 mr-20 mb-0">
          <FormattedMessage
            id="inactive-account-title"
            defaultMessage="Account not active"
          />
        </h1>
      </div>

      <div className="inactive-account-contact-support-button-container">
        <a
          className="nui-button new-request inactive-account-contact-support-button"
          href={supportLink}
        >
          <FormattedMessage
            id="contact-support-button"
            defaultMessage="Contact support"
          />
        </a>
      </div>

      <div className="inactive-account-container">
        <NoData className="mt--1 mb--1 p-100 b-0">
          <FormattedMessage
            id="inactive-account-message"
            defaultMessage="Your account is not active, please contact {supportLink}"
            values={{
              supportLink: <a href={supportLink}>support@nuimarkets.com</a>,
            }}
          />
        </NoData>
      </div>

      <Footer />
    </main>
  );
};
